import { render, staticRenderFns } from "./relief-type.vue?vue&type=template&id=122f7a4c"
import script from "./relief-type.vue?vue&type=script&lang=js"
export * from "./relief-type.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports